// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__26IH0","inputWrap":"CustomTip_inputWrap__BiM_-"};